// extracted by mini-css-extract-plugin
module.exports = {"square-button":"square-button__3Mcjk","primary":"primary__2UFCm","multicreator":"multicreator__151Ha"};